// import { useEffect, useState } from "react";
// import Modal from "components/common/Modal";
// import Alert from "components/common/Alert";
// import CurrencyTable from "./CurrencyTable";
// import CurrencyForm from "./CurrencyForm";
// import { useCurrency } from "./hooks/useCurrency";

// export default function CurrencyContainer() {
//   const {
//     data,
//     loading,
//     loadCurrencies,
//     addCurrency,
//     editCurrency,
//     deleteCurrency,
//   } = useCurrency();

//   const [openAdd, setOpenAdd] = useState(false);
//   const [editing, setEditing] = useState(null);
//   const [alert, setAlert] = useState({ type: "", message: "" });

//   const userId =
//     localStorage.getItem("user_id") || "69579c6190a653b640e65639";

//   useEffect(() => {
//     loadCurrencies();
//   }, []);

//   return (
//     <>
//       <div className="mb-4 flex justify-end">
//         <button
//           className="rounded bg-blue-600 px-4 py-2 text-white"
//           onClick={() => setOpenAdd(true)}
//         >
//           + Add Currency
//         </button>
//       </div>

//       {alert.message && (
//         <Alert
//           type={alert.type}
//           message={alert.message}
//           onClose={() => setAlert({ type: "", message: "" })}
//           autoClose
//         />
//       )}

//       <CurrencyTable
//         data={data}
//         loading={loading}
//         onEdit={setEditing}
//         onDelete={async (row) => {
//           try {
//             await deleteCurrency(row._id, {
//               is_deleted: true,
//               deleted_by: userId,
//             });
//             setAlert({
//               type: "success",
//               message: "Currency deleted successfully",
//             });
//             loadCurrencies();
//           } catch (error) {
//             setAlert({
//               type: "error",
//               message:
//                 error.response?.data?.message ||
//                 "Something went wrong while deleting currency",
//             });
//           }
//         }}
//       />

//       <Modal open={openAdd} onClose={() => setOpenAdd(false)}>
//         <CurrencyForm
//           onClose={() => setOpenAdd(false)}
//           onSubmit={async (payload) => {
//             try {
//               await addCurrency({
//                 ...payload,
//                 created_by: userId,
//               });
//               setAlert({
//                 type: "success",
//                 message: "Currency created successfully",
//               });
//               setOpenAdd(false);
//               loadCurrencies();
//             } catch (error) {
//               setAlert({
//                 type: "error",
//                 message:
//                   error.response?.data?.message ||
//                   "Something went wrong while creating currency",
//               });
//             }
//           }}
//         />
//       </Modal>

//       <Modal open={!!editing} onClose={() => setEditing(null)}>
//         <CurrencyForm
//           initialData={editing}
//           onClose={() => setEditing(null)}
//           onSubmit={async (payload) => {
//             try {
//               await editCurrency(editing._id, {
//                 ...payload,
//                 updated_by: userId,
//               });

//               setAlert({
//                 type: "success",
//                 message: "Currency updated successfully",
//               });

//               setEditing(null);
//               loadCurrencies();
//             } catch (error) {
//               setAlert({
//                 type: "error",
//                 message:
//                   error.response?.data?.message ||
//                   "Something went wrong while updating currency",
//               });
//             }
//           }}
//         />
//       </Modal>
//     </>
//   );
// }

import { useEffect, useState, useCallback } from "react";
import { MdSearch, MdAddBox } from "react-icons/md";
import TablePageLayout from "components/TablePageLayout";
import Pagination from "components/Pagination";
import CurrencyTable from "./CurrencyTable";
import CurrencyForm from "./CurrencyForm";
import Modal from "components/common/Modal";
import Alert from "components/common/Alert";
import { useCurrency } from "./hooks/useCurrency";
import CustomButton from "components/CustomButton";
import { InputField } from "components/FormFields";
import Toast from "components/Toast";

export default function CurrencyContainer() {
  const {
    data,
    loading,
    paginationInfo,
    loadCurrencies,
    addCurrency,
    editCurrency,
    deleteCurrency,
  } = useCurrency();

  const [openAdd, setOpenAdd] = useState(false);
  const [editing, setEditing] = useState(null);
  const [search, setSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [alert, setAlert] = useState({ type: "", message: "" });
  const [toast, setToast] = useState({
    open: false,
    title: "",
    message: "",
    type: "success",
  });

  const userId = localStorage.getItem("user_id") || "69579c6190a653b640e65639";

  // Debounce Search Input
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(search);
      setPage(1);
    }, 500);
    return () => clearTimeout(handler);
  }, [search]);

  const fetchData = useCallback(() => {
    loadCurrencies({
      page,
      limit,
      search: debouncedSearch,
    });
  }, [page, limit, debouncedSearch]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handleDeleteCurrency = async (row) => {
    try {
      await deleteCurrency(row._id, {
        is_deleted: true,
        deleted_by: userId,
      });
      setToast({
        open: true,
        title: "Success",
        message: "Currency deleted successfully",
        type: "success",
      });
      fetchData();
    } catch (error) {
      setToast({
        open: true,
        title: "Error",
        message: "Something went wrong while deleting currency",
        type: "error",
      });
    }
  };

  return (
    <TablePageLayout>
      <div className="grid w-full grid-cols-1 items-end gap-3 sm:grid-cols-2 lg:grid-cols-4">
        <div className="flex flex-col">
          <InputField
            label="SEARCH"
            name="search"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder="Search currency..."
            icon={<MdSearch className="text-lg text-gray-400" />}
          />
        </div>

        <div className="flex flex-col items-start justify-start gap-2 sm:col-span-3 sm:flex-row sm:justify-end lg:col-span-3">
          <CustomButton
            label="Add Currency"
            icon={MdAddBox}
            iconPos="right"
            variant="solid"
            color="#02a9e0"
            onClick={() => setOpenAdd(true)}
          />
        </div>
      </div>

      {alert.message && (
        <Alert
          type={alert.type}
          message={alert.message}
          onClose={() => setAlert({ type: "", message: "" })}
          autoClose
        />
      )}

      {loading ? (
        <div className="rounded-xl border bg-white p-12 text-center text-sm text-gray-500 shadow-sm">
          Loading currencies...
        </div>
      ) : (
        <div className="table-card overflow-hidden">
          <CurrencyTable
            data={data}
            onEdit={setEditing}
            onDelete={handleDeleteCurrency}
          />

          <Pagination
            currentPage={page}
            totalPages={paginationInfo.totalPages}
            totalEntries={paginationInfo.totalCurrencies}
            limit={limit}
            onPageChange={(newPage) => setPage(newPage)}
            onLimitChange={(newLimit) => setLimit(newLimit)}
          />
        </div>
      )}

      {/* Add Currency Modal */}
      <Modal
        open={openAdd}
        onClose={() => setOpenAdd(false)}
        title={"Create Currency"}
      >
        <CurrencyForm
          onClose={() => setOpenAdd(false)}
          onSubmit={async (payload) => {
            try {
              await addCurrency({
                ...payload,
                created_by: userId,
              });
              setToast({
                open: true,
                title: "Success",
                message: "Currency created successfully",
                type: "success",
              });
              setOpenAdd(false);
              fetchData();
            } catch (error) {
              setAlert({
                type: "error",
                message:
                  error.response?.data?.message ||
                  "Something went wrong while creating currency",
              });
            }
          }}
        />
      </Modal>

      {/* Edit Currency Modal */}
      <Modal
        open={!!editing}
        onClose={() => setEditing(null)}
        title={"Edit Currency"}
      >
        <CurrencyForm
          initialData={editing}
          onClose={() => setEditing(null)}
          onSubmit={async (payload) => {
            try {
              await editCurrency(editing._id, {
                ...payload,
                updated_by: userId,
              });
              setToast({
                open: true,
                title: "Success",
                message: "Currency updated successfully",
                type: "success",
              });
              setEditing(null);
              fetchData();
            } catch (error) {
              setAlert({
                type: "error",
                message:
                  error.response?.data?.message ||
                  "Something went wrong while updating currency",
              });
            }
          }}
        />
      </Modal>
      <Toast
        open={toast.open}
        title={toast.title}
        message={toast.message}
        type={toast.type}
        duration={1500}
        onClose={() => {
          setToast((prev) => ({ ...prev, open: false }));
        }}
      />
    </TablePageLayout>
  );
}
